'use client';

import { NavigationMenu } from '@/entities/navigation-menu/NavigationMenu';

export const InfoTopNavigationClient = () => {
  return <NavigationMenu menu="info" />;
};
